import axios from "axios";
import config from "../../Config";
import { logout } from "../../Modules/auth/logout";
import navigationModule from "../../Modules/navigation/navigationModule";
import { getStore } from "../../Providers/store";

let headers = {
  "Content-Type": "application/json",
};
let API_URL = config.apiUrl;

const getErMsg = (error) => {
  let erroObj = (error && error.response && error.response.data) || {};

  return erroObj.code === 500 || !(erroObj.message || error.message)
    ? "Something went wrong"
    : erroObj.message || error.message;
};

const getErCode = (error) => {
  let erroObj = (error && error.response && error.response.data) || {};

  return erroObj.code;
};

const catchError = (error, uri, opt) => {
  error.message = getErMsg(error);
  error.code = getErCode(error);
  console.warn(
    `Error in ${opt._method}:${API_URL + uri} status: ${
      error.response && error.response.status
    } message: ${getErMsg(error)}`
  );
  switch (error.response && error.response.status) {
    case 401:
      !opt?.noRedirect && logoutUser();
      break;
    default:
      break;
  }
  throw error;
};

const processRes = async (response, uri, opt) => {
  await processHeader(response.headers);
  return response.data;
};

const api = {};

api.download = (link) => {
  window.location.href = API_URL + link;
};

api.get = async (uri, params, option = {}) => {
  const opt = { ...option, _method: "GET" };
  const headers = await getHeaders(opt);

  return axios
    .get(API_URL + uri, {
      headers,
      params,
    })
    .then((res) => processRes(res, uri, opt))
    .catch((error) => catchError(error, uri, opt));
};

api.post = async (uri, payload, option = {}) => {
  const opt = { ...option, _method: "POST" };
  const headers = await getHeaders(opt);

  return axios
    .post(API_URL + uri, payload, {
      headers,
    })
    .then((res) => processRes(res, uri, opt))
    .catch((error) => catchError(error, uri, opt));
};

api.put = async (uri, payload, option = {}) => {
  const opt = { ...option, _method: "PUT" };
  const headers = await getHeaders(opt);

  return axios
    .put(API_URL + uri, payload, {
      headers,
    })
    .then((res) => processRes(res, uri, opt))
    .catch((error) => catchError(error, uri, opt));
};

api.patch = async (uri, payload, option = {}) => {
  const opt = { ...option, _method: "PATCH" };
  const headers = await getHeaders(opt);

  return axios
    .patch(API_URL + uri, payload, {
      headers,
    })
    .then((res) => processRes(res, uri, opt))
    .catch((error) => catchError(error, uri, opt));
};

api.delete = async (uri, payload, option = {}) => {
  const opt = { ...option, _method: "DELETE" };
  const headers = await getHeaders(opt);

  return axios
    .delete(API_URL + uri, {
      headers,
      data: payload,
    })
    .then((res) => processRes(res, uri, opt))
    .catch((error) => catchError(error, uri, opt));
};

api.formData = async (uri, payload = {}, option = {}) => {
  const { method = "post", cb } = option;
  const opt = { ...option, _method: `${method}_FORMDATA`.toUpperCase() };

  if (!["post", "put"].includes(method)) {
    throw new Error("Unsupported method");
  }

  let headers = await getHeaders(opt);
  headers = {
    ...headers,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  };

  let axiosConfig = {
    headers,
    onUploadProgress: function (progressEvent) {
      if (!cb) return;

      let percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      cb({ progress: percentCompleted });
    },
  };

  let formData = new FormData();

  Object.keys(payload).map((key) => {
    let value = payload[key];

    value =
      typeof value === "object" && ["photo", "file"].indexOf(key) === -1
        ? JSON.stringify(value)
        : value;

    formData.append(key, value);
    return value;
  });

  return axios[method](`${API_URL}${uri}`, formData, axiosConfig)
    .then((res) => processRes(res, uri, opt))
    .catch((error) => catchError(error, uri, opt));
};

api.media = async (uri = "v1/file", data = {}, option = {}) => {
  const { method = "post", cb } = option;
  const opt = { ...option, _method: `${method}_FORMDATA`.toUpperCase() };

  if (!["post", "put"].includes(method)) {
    throw new Error("Unsupported method");
  }

  let headers = await getHeaders(opt);
  headers = {
    ...headers,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  };

  let params = {};
  data.fileType && (params.fileType = data.fileType);
  data.public && (params.public = data.public);
  data.metaData && (params.metaData = data.metaData);

  let axiosConfig = {
    headers,
    params,
    onUploadProgress: function (progressEvent) {
      let percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      cb && cb(percentCompleted);
    },
  };

  var endpoint = API_URL + uri;

  let file = data.file || {};
  let formData = new FormData();

  if (data.file) {
    formData.append("file", file);
  } else {
    throw new Error("Missing valid required input");
  }

  return axios[method](endpoint, formData, axiosConfig)
    .then((res) => processRes(res, uri, opt))
    .catch((error) => catchError(error, uri, opt));
};

api.getFileLink = (id, opt = {}) => {
  const { height, width, video = false } = opt;

  id = id?._id || id;
  if (!id) return "";

  if (video) {
    return `${API_URL}v1/files/${id}`;
  }

  return `${API_URL}v1/files/${id}?height=${height || 0}&width=${width || 0}`;
};

api.getApiUrl = () => API_URL;

const processHeader = async (responHeaders = {}) => {
  return;
};

export const getSubdomain = () => {
  var full = window.location.host;
  var filtered = full.replace(config.hostName, "");
  var parts = filtered.split(".");
  var p1 = parts[0];

  var sub = p1.match(/\W+/) ? null : p1;
  return sub || "";
};

export const getHeaders = async (opt = {}) => {
  if (config.hostName.match(/^localhost/)) {
    await sleep(1000);
  }

  let result = {};

  const store = getStore();
  let token = store?.getState()?.pState?.user?.token;

  if (token) result = { ...result, authorization: "Bearer " + token };

  result = { ...result, ...(opt.headers || {}) };

  return result;
};

export const serialize = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

const logoutUser = () => {
  console.log({ headers, user: getStore()?.getState()?.user });
  if (["/login", "/signup"].find((x) => navigationModule.matchCurrentPath(x))) {
    return null;
  } else {
    logout();
    // navigationModule.gotoLogin();
  }
};

const sleep = (ms) =>
  new Promise((resolve) =>
    setTimeout(() => {
      resolve(true);
    }, ms)
  );

export default api;
